import { useMemo } from "react";
import { collection, query, where, orderBy } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useFirestoreCollection } from "./useFirestoreCollection";
import type { Invitation } from "@event-planner/shared";

export function useInvitations(eventId: string | undefined) {
  const q = useMemo(() => {
    if (!eventId) return null;
    return query(
      collection(db, "invitations"),
      where("eventId", "==", eventId),
      orderBy("createdAt", "desc"),
    );
  }, [eventId]);

  // Live: the email delivery status on each row flips from "sending" to
  // "delivered" / "failed" seconds after Send, driven by a Cloud Function
  // trigger. A listener updates that one row; polling re-rendered the table.
  return useFirestoreCollection<Invitation>(q);
}
